module.exports = __webpack_public_path__ + "img/thank_you_pic.76262c36.svg";